export const BRANDING_NAME = 'Refly';
